import { getDestinationCharges, getOriginCharges } from "./getOriginDestinationCharges";

/**
 * Get default port_fees_to charges for RESET_STATE
 * @param {Object} state - Redux state
 * @returns {Array} Formatted destination charges
 */
export const getResetPortFeesTo = (state, rate) => {
  // console.log("getResetPortFeesTo...........",state, rate);
  const defaultDestinationCharges = state?.defaultDestinationCharges || [];
  const excludedCharges = state?.rateProfile?.excluded_charges || [];
  const isDestinationMontreal = rate?.location_to?.id === 648992;
  const rateDestCharges = isDestinationMontreal ?  [] : rate?.destinationCharges || [];
  // console.log("defaultDestinationCharges: ",defaultDestinationCharges,
  //   "\nrateDestCharges: ", rateDestCharges,
  //   "\nexcludedCharges: ", excludedCharges
  // )
  const { destinationCharges, overseasCharge } = getDestinationCharges(
    defaultDestinationCharges,
    rateDestCharges,
    excludedCharges,
    rate
  );

   return destinationCharges;
  
  // return destinationCharges.length > 0 ? destinationCharges : [
  //   ["LLEO", "Legal Liability, Errors and Omissions Insurance", "5", "EA", "5", 284],
  //   ["HBL", "HBL Fee", "25", "EA", "25", 431],
  //   ["ACI", "ACI", "30", "EA", "30.00", 543],
  // ];
};

export const getResetPortFeesFrom = (state, rate) => {
  // console.log("getResetPortFeesFrom...........", state, rate);
  const rateOriginCharges = rate?.originCharges || [];
  // console.log("rateOriginCharges: ",rateOriginCharges)
  const originCharges = getOriginCharges(
    rateOriginCharges,
    rate
  );

  return originCharges;
};
